import { metresToFeet, msToKnots, prettyCallsign } from "../../lib/format.js";
import "./InstrumentTape.css";

// Vertical rate: m/s -> ft/min
const msToFpm = (ms) => (ms == null ? null : Math.round(ms * 196.85));

function Gauge({ label, value, unit, valueLabel, className, extra }) {
  return (
    <div
      className={`it-gauge ${className || ""}`}
      role="group"
      aria-label={valueLabel}
    >
      <div className="it-gauge-label">{label}</div>
      <div className="it-gauge-readout">
        <span className="it-value" aria-hidden="true">
          {extra}
          {value}
        </span>
        {unit ? (
          <span className="it-unit" aria-hidden="true">
            {unit}
          </span>
        ) : null}
      </div>
    </div>
  );
}

export default function InstrumentTape({ aircraft }) {
  if (!aircraft) {
    return (
      <div className="instrument-tape empty" role="group" aria-label="Instrument tape">
        <p className="it-placeholder muted">No aircraft selected</p>
      </div>
    );
  }

  const title = prettyCallsign(aircraft.callsign);

  const altFt = metresToFeet(aircraft.baroAltitude);
  const spdKt = msToKnots(aircraft.velocity);
  const fpm = msToFpm(aircraft.verticalRate);
  const hdg = aircraft.heading == null ? null : Math.round(aircraft.heading);

  // Vertical speed trend
  let vsClass = "level";
  let vsArrow = "=";
  let vsWord = "level";
  if (fpm != null) {
    if (fpm >= 60) {
      vsClass = "climb";
      vsArrow = "▲";
      vsWord = "climbing";
    } else if (fpm <= -60) {
      vsClass = "descent";
      vsArrow = "▼";
      vsWord = "descending";
    }
  }

  const altText = altFt == null ? "unknown" : `${altFt.toLocaleString()} feet`;
  const spdText = spdKt == null ? "unknown" : `${spdKt} knots`;
  const vsText =
    fpm == null
      ? "vertical speed unknown"
      : `${vsWord}, ${Math.abs(fpm).toLocaleString()} feet per minute`;
  const hdgText = hdg == null ? "unknown" : `${hdg} degrees`;

  return (
    <div className="instrument-tape" role="group" aria-label={`Instruments for ${title}`}>
      <div className="it-title">{title}</div>
      <div className="it-gauges">
        <Gauge
          label="ALT"
          value={altFt == null ? "––" : altFt.toLocaleString()}
          unit="ft"
          valueLabel={`Altitude ${altText}`}
        />
        <Gauge
          label="SPD"
          value={spdKt == null ? "––" : spdKt}
          unit="kt"
          valueLabel={`Speed ${spdText}`}
        />
        <Gauge
          label="V/S"
          className={`it-vs ${vsClass}`}
          extra={<span className="it-vs-arrow" aria-hidden="true">{vsArrow} </span>}
          value={fpm == null ? "––" : Math.abs(fpm).toLocaleString()}
          unit="fpm"
          valueLabel={`Vertical speed ${vsText}`}
        />
        <Gauge
          label="HDG"
          value={hdg == null ? "––" : String(hdg).padStart(3, "0")}
          unit="°"
          valueLabel={`Heading ${hdgText}`}
        />
      </div>
    </div>
  );
}
